import { jwtDecode } from 'jwt-decode'

export const mapUserFromToken = (token) => {
  const user = jwtDecode(token)
  return { ...user, authority: user.roles }
}

export function isMedicamentoCompleted(item) {
  const hasAllFields = (
    "laboratorio" in item &&
    "sustanciaFarmacologica" in item &&
    "nombreComercial" in item &&
    "presentacion" in item &&
    "dosificacion" in item &&
    "cantidad" in item
  );

  if (hasAllFields) {
    const allEmpty =
      !item.laboratorio &&
      !item.sustanciaFarmacologica &&
      !item.nombreComercial &&
      !item.presentacion &&
      !item.dosificacion &&
      item.cantidad === 0;
    return !allEmpty;
  }
  return false;
}
